import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
const scrollTable = () => {
  $('.--scroll').each(function () {
    let parent = $(this).parent()
    if (parent.innerWidth() < $(this).find('table').innerWidth()) {
      $(this).each(function (index, el) { new SimpleBar(el) });
      if (!$(this).prev().hasClass('scroll-note')) {
        $(this).before('<p class="scroll-note">※横にスクロールしてご覧いただけます</p>');
      }
      $(this).find('table').css('margin-bottom', '');
    } else {
      $(this).find('table').css('margin-bottom', '0');
      if ($(this).prev().hasClass('scroll-note')) {
        $(this).prev('.scroll-note').remove();
      }
    }
  });
}
export { scrollTable }
